import { render } from "./Surveys.vue?vue&type=template&id=0af9dbb8&scoped=true"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"

import "./Surveys.vue?vue&type=style&index=0&id=0af9dbb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af9dbb8"]])

export default __exports__